import { connect } from 'react-redux'
import { toggleShare } from '../../../store/actions/share'
import { compose, withProps, withHandlers } from 'recompose'
import { withTranslation } from 'react-i18next'
import getUrl from '../../../utils/getUrl'
import copy from 'copy-to-clipboard'
import { showNotification } from '../../../store/actions/alerts'

export default compose(
  withTranslation(),
  connect(
    null,
    (dispatch, props) => ({
      toggleShare: () => props.editable && dispatch(toggleShare(props.share)),
      showLinkCopied: () =>
        dispatch(showNotification(props.t('alert.linkCopied')))
    })
  ),
  withProps(({ share, item }) => ({
    link:
      window.location.origin + getUrl(item, { shareId: share.id || 'xxxxxx' })
  })),
  withHandlers({
    copyLink: ({ share, link, showLinkCopied }) => () => {
      if (!share.disabled) {
        copy(link)
        showLinkCopied()
      }
    }
  })
)
